export * from "gatsby-theme-blank/src/constants/index"

export const windowWidth = 900
export const coverSpeed = 0.65
export const dateDayMonthLength = 5
export const dateYearLength = -4
export const dateHourLength = 9
